// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2OzC_","container":"styles_container__36yAV","title":"styles_title__2lUHF","wrapper":"styles_wrapper__2P75s","answer":"styles_answer__24yB1"};